module.exports = __webpack_public_path__ + "media/3-star-wish-reveal.f6a4b73a.mp3";